import { render, staticRenderFns } from "./FeedbackDetails.vue?vue&type=template&id=465500ea&scoped=true&"
import script from "./FeedbackDetails.vue?vue&type=script&lang=js&"
export * from "./FeedbackDetails.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDetails.vue?vue&type=style&index=0&id=465500ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465500ea",
  null
  
)

export default component.exports